import { lazy } from "react";

const routes = [
  {
    path: "/product",
    element: lazy(() => import("../pages/Product")),
  },
  {
    path: "/product/add",
    element: lazy(() => import("../pages/Product/create")),
  },
  {
    path: "/product/edit/:id",
    element: lazy(() => import("../pages/Product/edit")),
  },
];

export default routes;
